// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__-LrcS","modal":"Notification_modal__O-YDb","notification-message":"Notification_notification-message__OpvMs"};